import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { environment } from '../environments/environment';

const routes: Routes = [
  { path: '', pathMatch: 'full', loadChildren: () => import('./pages/index/index.module').then((m) => m.IndexModule) },
  {
    path: 'admin/list-of-functions',
    loadChildren: () =>
      import('./modules/admin/list-of-functions/list-of-functions.module').then((m) => m.ListOfFunctionsModule),
  },
  { path: 'login', loadChildren: () => import('./pages/login/login.module').then((m) => m.LoginModule) },
  {
    path: environment.specialEndpoints.registration,
    loadChildren: () => import('./pages/registration/registration.module').then((m) => m.RegistrationModule),
  },
  {
    path: 'csomagok-es-arak',
    loadChildren: () => import('./pages/csomag-es-arak/csomag-es-arak.module').then((m) => m.CsomagEsArakModule),
  },
  {
    path: 'funkcio-lista/:id',
    loadChildren: () =>
      import('./pages/list-of-functions/list-of-functions.module').then((m) => m.ListOfFunctionsModule),
  },
  {
    path: 'rolunk',
    loadChildren: () => import('./pages/about-us/about-us.module').then((m) => m.AboutUsModule),
  },
  {
    path: 'kapcsolat',
    loadChildren: () => import('./pages/contact-us/contact-us.module').then((m) => m.ContactUsModule),
  },
  {
    path: 'atalanyado',
    loadChildren: () => import('./pages/atalanyado/atalanyado.module').then((m) => m.AtalanyadoModule),
  },
  {
    path: ':id',
    loadChildren: () => import('./pages/function-groups/function-groups.module').then((m) => m.FunctionGroupsModule),
  },
  { path: '**', loadChildren: () => import('./pages/page404/page404.module').then((m) => m.Page404Module) },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      anchorScrolling: 'enabled',
      relativeLinkResolution: 'legacy',
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
